import type { PodBrand } from '@/types/pod'

/**
 * The Hall's Roofing pod — branding layer (browser side).
 *
 * FOREDESK'S FIRST REAL CUSTOMER. Every pod before this one was the product
 * selling itself (foredesk/chamberflow) or a disposable demo (oxydise). This is
 * the first pod that is a paying business's own front of house: Hall's Roofing,
 * an Exeter/East Devon roofer, migrated off the earlier CallFirst assistant onto
 * the Foredesk engine. To their customers it must read as HALL'S OWN front desk,
 * not a third-party tool — so the palette, voice, and deferral target are all
 * theirs, and nothing here names Foredesk.
 *
 * SOURCE OF TRUTH. Every value below is lifted from Hall's live site config
 * (src/data/clientConfig.ts in their repo, verified 20 Jul 2026) — the contact
 * number, the tagline, the service scope. Nothing is invented; the same
 * discipline the grounding fence enforces on the corpus applies to the config.
 *
 * PALETTE. Matches Hall's existing site chrome — deep slate primary with their
 * amber/ochre accent (#d97706, their tailwind brand-500). This is the look their
 * customers already associate with the business; tune once seen live in the
 * engine UI.
 *
 * CONTACT. Phone only — their site config carries no email. If Hall's supply a
 * monitored business inbox later, add it here; until then the assistant defers
 * to the phone, which is correct and real.
 */
export const hallsPod: PodBrand = {
  id: 'halls',
  brandName: "Hall's Roofing",
  productName: "Hall's Roofing",
  assistantName: 'Rafferty',
  tagline: 'Trusted roofers across Exeter and East Devon',
  roleLabel: 'roofing assistant',
  welcomeIntro:
    "Got a roof problem? Tell me what's happening and I'll help. Leaks, repairs, new roofs, flat roofs, chimneys and guttering — anywhere in Exeter or East Devon. Want a free quote? Give me a few details and Mike will call you back.",
  starters: [],
  inputPrompt: 'Ask Rafferty about your roof',
  footerNote:
    "Rafferty answers from Hall's Roofing's own information — anything else goes straight to Mike.",
  theme: {
    // Hall's palette — deep slate + amber, matching their existing site chrome
    // so the assistant reads as their own front desk, not a bolt-on.
    '--color-brand-primary': '30 41 59', // slate-800 #1E293B
    '--color-brand-primary-hover': '15 23 42', // slate-900 #0F172A
    '--color-brand-accent': '217 119 6', // amber #D97706 (their brand-500)
    '--color-surface-base': '248 250 252', // slate-50 #F8FAFC
    '--color-surface-raised': '255 255 255',
    '--color-surface-subtle': '241 245 249', // slate-100 #F1F5F9
    '--color-text-primary': '30 41 59', // slate-800 #1E293B
    '--color-text-muted': '100 116 139', // slate-500 #64748B
    '--color-text-danger': '178 47 47',
    '--color-border-subtle': '226 232 240', // slate-200 #E2E8F0
  },
  contact: {
    phone: '07455 700757',
  },
}
